.triggers {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.triggerList {
  display: flex;
  flex-direction: column;
  background-color: $black-10;
  border: 1px solid $white-10;
  border-radius: $component-border-radius-md;
  overflow: hidden;
}

.triggerHeader {
  display: grid;
  grid-template-columns: 8rem 1fr 2rem;
  gap: 0.5rem;
  padding: 0.375rem 0.75rem;
  font-size: $aux-text-size;
  color: $label-gray;
}

.trigger {
  padding: 0.5rem 0.75rem;
  display: grid;
  grid-template-columns: 8rem 1fr 2rem;
  align-items: center;
  gap: 0.5rem;
  min-height: 2.5rem;

  &:not(:first-child) {
    border-top: 1px solid $white-10;
  }

  &[data-duplicate] {
    > button:not(:last-child) {
      border-color: $orange-500;
    }
  }
}

.duplicateMessage {
  padding-left: 0.75rem;
  font-size: $aux-text-size;
  color: $orange-500;
}
